import { serviceApi } from '~/api';

const getPageCopyUrl = (appointmentTypeId) => `appointment-types/${appointmentTypeId}/page-copy`;

const getPageCopy = (appointmentTypeId) =>
  serviceApi.fetchJSON(getPageCopyUrl(appointmentTypeId), {
    method: 'GET',
  });

export const pageCopyApi = { getPageCopy };
